import React, { useId } from 'react';
import { InfoIcon } from 'lucide-react';
interface Props {
  label: string;
  type?: 'text' | 'textarea' | 'number' | 'email' | 'password';
  value: string | number;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  tooltip?: string;
  placeholder?: string;
  min?: number;
  max?: number;
  disabled?: boolean;
  name?: string; // Add name prop
}
export const FormField = ({
  label,
  type = 'text',
  value,
  onChange,
  error,
  required,
  tooltip,
  placeholder,
  min,
  max,
  disabled,
  name // Add name to props
}: Props) => {
  const id = useId(); // Generate unique id
  const fieldName = name || id; // Use provided name or fallback to id
  const baseInputStyles = `
    w-full px-3 sm:px-4 py-2 bg-surface-mid border rounded-none text-base transition-all duration-200
    text-white placeholder-gray-400 min-h-[40px]
    ${error ? 'border-status-error focus:border-status-error focus:ring-status-error' : 'border-surface-border focus:border-accent focus:ring-accent'}
    ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
  `;
  return <div className="space-y-2" data-id="element-408">
      <div className="flex items-center gap-2" data-id="element-409">
        <label htmlFor={id} className="text-sm font-medium text-gray-300" data-id="element-410">
          {label}
          {required && <span className="ml-1 text-status-error" data-id="element-411">*</span>}
        </label>
        {tooltip && <div className="group relative" data-id="element-412">
            <InfoIcon size={14} className="text-gray-400 hover:text-gray-300 cursor-help transition-colors" data-id="element-413" />
            <div className="absolute left-0 sm:left-full top-full sm:top-auto sm:ml-2 w-64 p-2.5 bg-surface-light border 
                        border-surface-border rounded-none text-xs text-gray-300 invisible opacity-0 
                        group-hover:visible group-hover:opacity-100 transition-all duration-200 z-10
                        mt-1 sm:mt-0" data-id="element-414">
              {tooltip}
            </div>
          </div>}
      </div>
      {type === 'textarea' ? <textarea id={id} name={fieldName} value={value} onChange={e => onChange(e.target.value)} className={`${baseInputStyles} min-h-[100px] sm:min-h-[120px] resize-y py-3`} placeholder={placeholder} disabled={disabled} required={required} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${id}-error` : undefined} data-id="element-415" /> : <input id={id} name={fieldName} type={type} value={value} onChange={e => onChange(e.target.value)} className={baseInputStyles} placeholder={placeholder} min={min} max={max} disabled={disabled} required={required} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${id}-error` : undefined} data-id="element-416" />}
      {error && <p id={`${id}-error`} className="text-sm text-status-error mt-1.5" role="alert" data-id="element-417">
          {error}
        </p>}
    </div>;
};